import React from "react";
import { StyledDescription } from "../styled";

export const DescriptionText = ({ children }) => <StyledDescription>{children}</StyledDescription>;


